import type { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'

let axiosInstance: AxiosInstance | null = null

export const setApiClient = (client: AxiosInstance): void => {
  axiosInstance = client
}

export const customInstance = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  if (!axiosInstance) {
    throw new Error('@roko/api: axios instance not set. Call setApiClient() during app bootstrap.')
  }

  return axiosInstance({ ...config, ...options }).then(({ data }) => data)
}

export type ErrorType<Error> = AxiosError<Error>
